import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
// Initialize Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'crema-react.firebaseapp.com',
  databaseURL: 'https://crema-react.firebaseio.com',
  projectId: 'crema-react',
  storageBucket: 'crema-react.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let firebaseReady = false;
if (!firebase.apps.length) {
  try {
    firebase.initializeApp(firebaseConfig);
    firebaseReady = true;
  } catch (_error) {
    firebaseReady = false;
  }
} else {
  firebaseReady = true;
}

let auth: firebase.auth.Auth | null = null;
try {
  if (firebaseReady && firebase.apps.length) {
    auth = firebase.auth();
  }
} catch (_error) {
  auth = null;
}

let googleAuthProvider: firebase.auth.GoogleAuthProvider | null = null;
let githubAuthProvider: firebase.auth.GithubAuthProvider | null = null;
let facebookAuthProvider: firebase.auth.FacebookAuthProvider | null = null;
let twitterAuthProvider: firebase.auth.TwitterAuthProvider | null = null;
try {
  if (firebaseReady) {
    googleAuthProvider = new firebase.auth.GoogleAuthProvider();
    githubAuthProvider = new firebase.auth.GithubAuthProvider();
    facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
    twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
  }
} catch (_error) {
  googleAuthProvider = null;
  githubAuthProvider = null;
  facebookAuthProvider = null;
  twitterAuthProvider = null;
}

export {
  auth,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
};
